type Font = {
  fontFamily: string
  fontWeight: number
  cropFontSize: number
  cropLineHeight: number
  topCrop: number
  bottomCrop: number
}

// Crop the Em Square to the baseline and cap height of the font face
// See:
// https://medium.com/eightshapes-llc/cropping-away-negative-impacts-of-line-height-84d744e016ce
const fontCrop = ({
  fontFamily,
  fontWeight,
  cropFontSize,
  cropLineHeight,
  topCrop,
  bottomCrop
}: Font) => (lineHeight = 1.2, topAdjustment = 0, bottomAdjustment = 0) => {
  const dynamicCropTop =
    Math.max(topCrop + (lineHeight - cropLineHeight) * (cropFontSize / 2), 0) /
    cropFontSize
  const dynamicCropBottom =
    Math.max(
      bottomCrop + (lineHeight - cropLineHeight) * (cropFontSize / 2),
      0
    ) / cropFontSize

  return {
    fontFamily,
    fontWeight,
    lineHeight,
    ":before": {
      display: "block",
      content: "''",
      height: 0,
      marginTop: `calc(-${dynamicCropTop}em + ${topAdjustment}px)`,
      width: 0
    },
    ":after": {
      display: "block",
      content: "''",
      height: 0,
      marginTop: `calc(-${dynamicCropBottom}em + ${bottomAdjustment}px)`,
      paddingBottom: 1,
      width: 0
    }
  }
}

export { fontCrop }
